// extracted by mini-css-extract-plugin
module.exports = {"deeplinkUrl":"styles_deeplinkUrl__2xntT"};